/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { AllowedRoleMappingService } from '../../services/wealthlane-identity-services';
import { Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse } from '../../services/wealthlane-identity-services/models/Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse';

const usePostAllowedCompanyMappingManage = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  modalStatus: string
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse | undefined,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        AllowedRoleMappingService.postApiIdentityApiAllowedRoleMappingManage(payload)
      );
    },
    {
      onSuccess: (response) => {
        if (response != null) {
          closeModal();
          void queryClient.invalidateQueries('getAllowedRoleMappings');
          toast.success(
            <ToastComponent label='Success' message={`Allowed Role Mapping ${modalStatus}ed.`} />
          );
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostAllowedCompanyMappingManage;
